"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuSelectCheckbox = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_icon_1 = require("@hopin-team/ui-icon");

var ui_text_1 = require("@hopin-team/ui-text");

var react_1 = tslib_1.__importStar(require("react"));

var context_1 = require("../context");

var select_checkbox_1 = require("../styled/select-checkbox");

var MenuSelectCheckbox = function MenuSelectCheckbox(_a) {
  var __UIScope = _a.__UIScope,
      testID = _a["data-testid"],
      selected = _a.selected,
      className = _a.className,
      label = _a.label,
      onClick = _a.onClick,
      _b = _a.role,
      role = _b === void 0 ? 'menuitemcheckbox' : _b,
      subtext = _a.subtext;
  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'MenuSelectCheckbox',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;

  var _c = (0, react_1.useContext)(context_1.MenuContext),
      onItemSelected = _c.onItemSelected,
      isInverse = _c.isInverse;

  var clickHandler = function clickHandler(e) {
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
    onItemSelected === null || onItemSelected === void 0 ? void 0 : onItemSelected();
  };

  return react_1.default.createElement(select_checkbox_1.SelectCheckbox, {
    className: rootClasses,
    "data-testid": testID,
    role: role,
    isInverse: isInverse,
    "aria-checked": selected,
    selected: selected,
    onClick: clickHandler
  }, selected ? react_1.default.createElement(ui_icon_1.Icon, {
    name: "single-select",
    color: "utility-action"
  }) : react_1.default.createElement(select_checkbox_1.Checkbox, null), react_1.default.createElement(select_checkbox_1.Content, {
    flexDirection: (subtext === null || subtext === void 0 ? void 0 : subtext.position) === 'right' ? 'row' : 'column',
    justifyContent: (subtext === null || subtext === void 0 ? void 0 : subtext.position) === 'right' ? 'space-between' : 'flex-start'
  }, label, (subtext === null || subtext === void 0 ? void 0 : subtext.label) && react_1.default.createElement(ui_text_1.Text, {
    color: isInverse ? 'grey-white' : 'grey-medium',
    pattern: (subtext === null || subtext === void 0 ? void 0 : subtext.position) === 'bottom' ? 'caption' : 'body',
    ml: (subtext === null || subtext === void 0 ? void 0 : subtext.position) === 'right' ? 1.5 : 0
  }, subtext === null || subtext === void 0 ? void 0 : subtext.label)));
};

var MenuSelectCheckboxWithSpace = (0, ui_helper_with_space_1.withSpace)(MenuSelectCheckbox);
exports.MenuSelectCheckbox = MenuSelectCheckboxWithSpace;